import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
/*import { Col, Row } from 'reactstrap';
import TypeformView from '../../TypeformView'
import $ from 'jquery';
import uuid from 'uuid';
import DataLoader from '../../../../app/DataLoader'*/
import CMMCAssessmentContent from './CMMCAssessmentContent';
import { toggleTourOn } from '../../../../redux/actions/toggleTourActions';
import { 
    Button,
    withStyles 
  } from '@material-ui/core';

  const useStyles = (theme) => ({
    nextButton: {
      background: '#5B9FAB',
      color: 'white',
      paddingLeft: '35px',
      paddingRight: '35px',
      '&:hover': {
        background: '#5B9FAB',
        borderColor: '#5B9FAB',
        color: '#000'
      },
    },
    buttonPadding: {
        paddingBottom: '50px'
    }
  });

class CMMCAssessment extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            categoryIndex: 0,
            isActive: true,
            hoverColor: true,
            bgColr: "white-bg",
            loading: true,
            loaded: false,
            updateForm: true,
            forms: [],
            showTourButton: false
        }
        this.setShowTourButton = this._setShowTourButton.bind(this)
    }

    _setShowTourButton(){
        this.setState({showTourButton:true});
    }

    toggleTour = () => {
        this.props.dispatch(toggleTourOn());
        this.props.history.push('/app/tour/playbook')
    };

    render () {
        const { classes } = this.props;
        return (
                <div>
                    <CMMCAssessmentContent setShowTourButton={this.setShowTourButton}/>
                    { this.state.showTourButton && localStorage.getItem('fromGettingStarted') === 'true' ? 
                        <div className="row d-flex justify-content-center">
                            <div className={classes.buttonPadding}>
                                <Button 
                                    variant="outlined"
                                    onClick={()=>{
                                        this.toggleTour();
                                    }} 
                                    className={classes.nextButton}>
                                        Take a tour of Posture
                                </Button>
                            </div>
                        </div>
                    : null }
                </div >
        )
    }
}



function mapStateToProps (state) {
    return {
        user: state.auth.user,
        tenant: state.auth.tenant,
        enabledFrameworks: state.controlsData.enabledFrameworks,
        dataLoaded: !state.controlsData.loading,
        sidebar: state.sidebar
    }
}

export default connect(mapStateToProps)(withRouter((withStyles(useStyles)(CMMCAssessment))))


// WEBPACK FOOTER //
// ./src/components/assessment/components/CMMC/CMMCAssessment.js